import { gql } from 'graphql-request';

import withFragments from 'utils/graphql';

import Hero from 'fragments/Hero';
import Video from 'fragments/Video';
import ChecklistImage from 'fragments/ChecklistImage';
import ActivitySchedule from 'fragments/ActivitySchedule';
import ActivityPrice from 'fragments/ActivityPrice';
import Logo from 'fragments/Logo';

export default withFragments(
  gql`
    query($id: Int, $contentType: String!, $token: String!) {
      page(id: $id, contentType: $contentType, token: $token) {
        id
        url
        title
        slug
        seoTitle
        seoDescription
        ... on ActivityPage {
          metaImage {
            url
          }
          metaTitle
          metaDescription
          logo {
            ...Logo
          }
          socialShareTitle
          title
          url
          checklist
          breadcrumbs {
            title
            url
          }
          activity {
            title
            descriptionTitle
            description
            descriptionRt
            areaChoiceDisplay
            embedUrl
            embedHtml
            descriptionLower
            checklistTitle
            checklistImage {
              ...ChecklistImage
            }
            heroFallbackImage {
              ...Hero
            }
            heroVideo {
              ...Video
            }
            theme {
              icon
              name
            }
          }
          schedule {
            ...ActivitySchedule
          }
          price {
            ...ActivityPrice
          }
        }
      }
    }
  `,
  { Hero, Video, ChecklistImage, ActivitySchedule, ActivityPrice, Logo },
);
